import { render, staticRenderFns } from "./InitialVisibilityCollpase.vue?vue&type=template&id=53a8a891"
import script from "./InitialVisibilityCollpase.vue?vue&type=script&lang=js"
export * from "./InitialVisibilityCollpase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports